import React from "react";
import { Icon, Spin, Table } from "antd";
import { Modal } from '../../helpers/commonUi'
import { IOrgListCards } from "./org";
// import moment from 'moment'
import { Http } from "../../helpers/axois";
import Style from "./orgs.module.sass";
import { ReactComponent as OrgIcon } from "../../assets/svg/organizationIcon.svg";
import { setOrgList, setCurrentOrganization } from "../../stateManager/store/orgs/actions";
import { pushToast } from "../../stateManager/store/toast/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import NoData from '../apps/NoData';
import { ReactComponent as TableEdit } from '../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../assets/svg/delete.svg'

import CreateOrgModal from "../organization/CreateOrgs";
import SearchBar, { highlightMatch } from "../../helpers/SearchBar";

interface states {
  visible: boolean;
  cardError: string;
  editvisible: boolean;
  editvisibleInDom: boolean;
  editableOrgData: IOrgListCards;
  orgloading: boolean;
  editOrgModalVisible: boolean;
  createOrgModalVisible: boolean;
  deleteorg: IOrgListCards;
  [key: string]: any;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

interface Iprops {
  orgList: any[];
  history: any;
  setOrgList: (data: any) => void;
  pushToast: (data: any) => void;
}

class OrgList extends React.Component<Iprops, states> {
  constructor(props: any) {
    super(props);
    this.state = {
      visible: false,
      cardError: "",
      editvisible: false,
      editableOrgData: {},
      editvisibleInDom: false,
      orgloading: false,
      deleteorg: {},
      editOrgModalVisible: false,
      createOrgModalVisible: false,
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef()
    };
    this.toggleEditModalVisibility = this.toggleEditModalVisibility.bind(this)
    this.toggleCreateModalVisibility = this.toggleCreateModalVisibility.bind(this)
  }

  loadAPIcards = () => {
    this.state.searchRef.current?.clearSearch()
    Http.get("/orgs/list").subscribe(
      (res: any) => {
        this.setState({
          orgList: res,
          filteredData: res,
          cardError: "",
          orgloading: false
        });
        this.props.setOrgList({
          orgList: res
        })
      },
      error => {
        this.setState({ cardError: error.message, orgloading: false, filteredData: [] });
      }
    );
  };

  componentDidMount() {
    this.setState({ orgloading: true });
    setTimeout(() => {
      this.loadAPIcards();
    }, 400);
  }

  toggleEditModalVisibility(status: boolean) {
    this.setState({
      editOrgModalVisible: status
    })
  }

  toggleCreateModalVisibility(status: boolean) {
    this.setState({
      createOrgModalVisible: status
    })
  }

  editOrgs(orgs: IOrgListCards) {
    this.setState({
      visible: true
    });
  }
  content = (org: any) => {
    return (
      <div>
        <p
          data-test-id="edit"
          style={{ cursor: "pointer", color: "#292d32" }}
          onClick={e => {
            this.setState({

              [org.id]: false
            });
            this.props.history.push(`/organization/${org.id}/edit`);
            e.stopPropagation();
          }}
        >
          Edit
        </p>
        <p
          data-test-id="delete"
          style={{ cursor: "pointer", color: "#292d32" }}
          onClick={e => {
            e.stopPropagation();
            this.setState({
              deleteorg: org,
              visible: true,
              [org.id]: false
            });
          }}
        >
          Delete
        </p>
      </div>
    );
  };

  render() {
    let {
      visible,
      deleteorg,
      orgloading,
    } = this.state;

    // const permissions = this.props.orgPermissions
    // const canEditOrg = permissions.includes('org.Edit')
    // const canDeleteOrg = permissions.includes('org.Delete')

    const columns = [
      {
        title: "Name (identifier)",
        dataIndex: "orgName",
        key: "orgName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        },
        width: "20%"
      },
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        },
        width: "20%"
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        },
        ellipsis: true,
        width: "45%",
        className: "descriptionColumn"
      },
      {
        title: "Action",
        key: "action",
        width: "15%",
        render: (text: any, record: any) => {
          const canEditOrg = record.permissions.includes('org.Edit')
          const canDeleteOrg = record.permissions.includes('org.Delete')
          return (
            <div className="action">
              <span
                data-test-id="action_edit"
                title="Edit"
                className="action-icon edit-icon"
                onClick={e => {
                  e.stopPropagation();
                  if (canEditOrg) {
                    this.setState({
                      editableOrgData: record,
                      [record.id]: false,
                      editOrgModalVisible: true
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this organization'
                    })
                  }
                }}
              >
                <TableEdit height='21px' width='21px' />
              </span>
              <span
                data-test-id="action_delete"
                className="action-icon delete-icon"
                title="Delete"
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (canDeleteOrg) {
                    this.setState({
                      deleteorg: record,
                      visible: true,
                      [record.id]: false
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to delete this organization'
                    })
                  }
                }}
              >
                <Delete />
              </span>
            </div>
          )
        }
      }
    ]

    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

    return (
      <React.Fragment>
        <div className={Style.mainorgs}>
          {!orgloading ? (
            <React.Fragment>
              {this.props.orgList && this.props.orgList.length > 0 ? (
                <React.Fragment>
                  <div className="flex justify-end mb-2">
                    <SearchBar
                      ref={this.state.searchRef}
                      data={this.state.orgList}
                      columns={columns}
                      onFilter={(filteredData ) => {
                        this.setState({
                          filteredData: filteredData,
                        })
                      }}
                      onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                    />
                  </div>
                  <Table
                    data-test-id="orgs_list"
                    pagination={false}
                    columns={columns}
                    className={"override-table-container"}
                    dataSource={this.state.filteredData.map((res: any) => {
                      return { ...res, key: res.id };
                    })}
                  />
                </React.Fragment>
              )
                :
                <NoData
                  svg={OrgIcon}
                  header='Create Organization'
                  content='Create organization to start creating apps'
                  svgFill="#052f35 "
                  // buttonText='Create new version'
                  buttonCallback={() => this.setState({
                    createOrgModalVisible: true
                  })}
                />
              }
            </React.Fragment>
          ) : (
            <div className={Style.loadingSpinner}>
              <Spin indicator={antIcon} style={{ color: '#15808C' }} />
            </div>
          )}
          <DeleteOrgModal
            loadAPIcards={this.loadAPIcards}
            visible={visible}
            deleteorg={deleteorg}
            visibleChange={value => {
              this.setState({ visible: value });
            }}
          />
          <CreateOrgModal visible={this.state.createOrgModalVisible} visibleChange={this.toggleCreateModalVisibility} loadAPIcards={this.loadAPIcards} />
          <CreateOrgModal visible={this.state.editOrgModalVisible} visibleChange={this.toggleEditModalVisibility} editable={true} orgdata={this.state.editableOrgData} loadAPIcards={this.loadAPIcards} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any, props: any) => {
  return {
    orgList: state.org.orgList
  };
};

export default connect(
  mapStateToProps,
  { setOrgList, pushToast }
)(OrgList);


interface IdeleteMadal {
  loadAPIcards: () => void
  visible: boolean;
  deleteorg: IOrgListCards;
  visibleChange: (visible: any) => void;
}

const DeleteOrgModal = ({
  visible,
  loadAPIcards,
  deleteorg,
  visibleChange
}: IdeleteMadal) => {

  const dispatch = useDispatch()
  const currentOrganzation = useSelector((state: any) => {
    return state.org.selectedOrg
  })
  const orgList = useSelector((state: any) => state.org.orgList)

  const handleOk = () => {
    Http.put(`/orgs/delete/${deleteorg.id}`).subscribe((res: any) => {
      if (currentOrganzation.id === deleteorg.id) {
        const filteredArray = orgList.filter((item: any) => (item.id !== deleteorg.id))
        if (filteredArray.length > 0) {
          dispatch(setCurrentOrganization({ selectedOrg: { id: filteredArray[0].id, orgName: filteredArray[0].orgName, owner: filteredArray[0].owner } }))
        } else {
          dispatch(setCurrentOrganization({ selectedOrg: { id: '', orgName: '', owner: '' } }))
        }
      }
      loadAPIcards();
      visibleChange(false);
    })
  };
  const handleCancel = () => {
    visibleChange(false);
  };
  return (
    <Modal
      id="deleteOrg"
      dataTestId="delete_org"
      unmountOnCancel={true}
      visible={visible}
      title="DELETE ORGANIZATION"
      onCancel={handleCancel}
      // mode='Delete'
      deleteOptions={{
        type: "Organization",
        terms: [
          'All apps will be deleted from organization',
          'All teams will be deleted from organization',
          'All settings and permissions will be removed'
        ],
        validateString: deleteorg.orgName
      }}
      footer={{
        enable: true,
        okText: 'DELETE',
        cancelText: 'CANCEL',
        onOk: handleOk
      }}
    />
  );
};
